import React from 'react';
import { Query } from 'react-apollo';

import GolfCourse from '~/components/GraphQLEventDescriptionCard/LeagueCards/GolfCourse';

import GolfEventCourse from '~/graphql/queries/GolfEventCourse.graphql';

const GolfCourseContainer = ({ event }) => (
  <Query query={GolfEventCourse} variables={{ golfEventId: event.id }}>
    {({ loading, error, data }) => {
      if (error || loading) return null;

      return <GolfCourse data={data} />;
    }}
  </Query>
);

export default GolfCourseContainer;
